<!-- routerLinkUrl -->
<a
  [routerLink]="routerLinkUrl"
  [skipLocationChange]="skipLocationChange"
  class="link tui-text_body-m-6 lg:tui-text_body-m-4"
  *ngIf="routerLinkUrl"
  [ngClass]="{
    short: basePanelService.routeData.shortLeftNavigation,
    active: isMatchActiveClass()
  }"
>
  <div class="link__icon relative">
    <div
      *ngIf="notificationsCount !== ''"
      class="notifications-count tui-accent-17-bg"
    >
      {{ notificationsCount }}
    </div>

    <svg-icon [src]="iconSrc"></svg-icon>
  </div>
  <span>{{ name }}</span>

  <!-- chevron icon for dropdowns -->
  <div
    *ngIf="dropdownIcon"
    class="icon-chevron-dropdown"
  >
    <tui-svg
      class="text-white cursor-pointer"
      [src]="'tuiIconChevronDownLarge'"
    ></tui-svg>
  </div>
</a>

<!-- href -->
<a
  [href]="href"
  target="_blank"
  class="tui-text_body-m-6 lg:tui-text_body-m-4"
  *ngIf="href"
  [ngClass]="{ short: basePanelService.routeData.shortLeftNavigation }"
>
  <svg-icon [src]="iconSrc"></svg-icon>
  <span>{{ name }}</span>
</a>
